import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 用户&管理员部分
 *
 */

/**
 * 管理员登入
 * @param {*} query
 */
export const adminLogin = (query) => {
  return request({
    url: `${prefix}/admin/login`,
    method: 'post',
    data: query
  })
}

/**
 * 管理员登出
 * @param {*} query
 */
export const adminLogout = (query) => {
  return request({
    url: `${prefix}/admin/logout`,
    method: 'post',
    data: query
  })
}


/**
 * 管理员查询：列表
 * @param {*} query
 */
export const adminList = (query) => {
  return request({
    url: `${prefix}/admin/list`,
    method: 'get',
    params: query
  })
}

/**
 * 管理员查询
 * @param {*} query
 */
export const adminOne = (query) => {
  return request({
    url: `${prefix}/admin`,
    method: 'get',
    params: query
  })
}

/**
 * 管理员创建
 * @param {*} query
 */
export const adminCreate = (query) => {
  return request({
    url: `${prefix}/admin`,
    method: 'post',
    data: query
  })
}

/**
 * 管理员修改
 * @param {*} query
 */
export const adminUpdate = (query) => {
  return request({
    url: `${prefix}/admin`,
    method: 'put',
    data: query
  })
}

/**
 * 管理员删除
 * @param {*} query
 */
export const adminDestroy = (query) => {
  return request({
    url: `${prefix}/admin`,
    method: 'delete',
    data: query
  })
}

/**
 * 管理员删除：列表
 * @param {*} query
 */
export const adminRemoves = (query) => {
  return request({
    url: `${prefix}/admin/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 管理角色查询：列表
 * @param {*} query
 */
export const adminRoleList = (query) => {
  return request({
    url: `${prefix}/admin/role/list`,
    method: 'get',
    params: query
  })
}
/**
 * 管理角色查询
 * @param {*} query
 */
export const adminRoleOne = (query) => {
  return request({
    url: `${prefix}/admin/role`,
    method: 'get',
    params: query
  })
}
/**
 * 管理角色更新
 * @param {*} query
 */
export const adminRoleUpdate = (query) => {
  return request({
    url: `${prefix}/admin/role`,
    method: 'put',
    data: query
  })
}
/**
 * 管理角色创建
 * @param {*} query
 */
export const adminRoleCreate = (query) => {
  return request({
    url: `${prefix}/admin/role`,
    method: 'post',
    data: query
  })
}
/**
 * 管理角色删除
 * @param {*} query
 */
export const adminRoleDestroy = (query) => {
  return request({
    url: `${prefix}/admin/role`,
    method: 'delete',
    data: query
  })
}
/**
 * 管理权限查询：列表
 * @param {*} query
 */
export const adminRuleList = (query) => {
  return request({
    url: `${prefix}/admin/rule/list`,
    method: 'get',
    params: query
  })
}
/**
 * 管理权限查询
 * @param {*} query
 */
export const adminRuleOne = (query) => {
  return request({
    url: `${prefix}/admin/rule`,
    method: 'get',
    params: query
  })
}
/**
 * 管理权限更新
 * @param {*} query
 */
export const adminRuleUpdate = (query) => {
  return request({
    url: `${prefix}/admin/rule`,
    method: 'put',
    data: query
  })
}
/**
 * 管理权限创建
 * @param {*} query
 */
export const adminRuleCreate = (query) => {
  return request({
    url: `${prefix}/admin/rule`,
    method: 'post',
    data: query
  })
}
/**
 * 管理权限删除
 * @param {*} query
 */
export const adminRuleDestroy = (query) => {
  return request({
    url: `${prefix}/admin/rule`,
    method: 'delete',
    data: query
  })
}
/**
 * 管理权限查询：列表
 * @param {*} query
 */
export const adminPermissions = (query) => {
  return request({
    url: `${prefix}/admin/permissions`,
    method: 'get',
    params: query
  })
}

/**
 * 管理员部门（查询列表）
 * @param {*} query
 */
export const deptlist = (query) => {
  return request({
    url: `${prefix}/admin/dept/list`,
    method: 'get',
    params: query
  })
}


/**
 * 管理员部门（创建）
 * @param {*} query
 */
export const deptCreate = (query) => {
  return request({
    url: `${prefix}/admin/dept`,
    method: 'post',
    data: query
  })
}

/**
 * 管理员部门删除
 * @param {*} query
 */
export const deptDestroy = (query) => {
  return request({
    url: `${prefix}/admin/dept`,
    method: 'delete',
    data: query
  })
}

/**
 * 管理员部门修改
 * @param {*} query
 */
export const deptEdit = (query) => {
  return request({
    url: `${prefix}/admin/dept`,
    method: 'put',
    data: query
  })
}
